import { render, staticRenderFns } from "./FindPwd.vue?vue&type=template&id=554126dc&scoped=true"
import script from "./FindPwd.vue?vue&type=script&lang=js"
export * from "./FindPwd.vue?vue&type=script&lang=js"
import style0 from "./FindPwd.vue?vue&type=style&index=0&id=554126dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554126dc",
  null
  
)

export default component.exports